import React from "react";
import Link from "../../../../utils/Link";

export default function Logo() {
  return (
    <Link
      to="/"
      className="header-wrapper__logo header-wrapper__logo--corporate"
    >
      <img
        src="/images/fibank-logo.svg"
        className="header-wrapper__logo-element"
        alt="Fibank"
      />
      <img
        src="/images/fibank-logo-white.svg"
        className="header-wrapper__logo-element header-wrapper__logo-element--alt"
        alt="Fibank"
      />
      <strong className="sr">Fibank</strong>
    </Link>
  );
}
